import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Category } from '../../../models/category';
import * as categoryActions from './category.actions';

export interface CategoryState extends EntityState<Category> {
  loadingCategory: boolean;
  categoryLoaded: boolean;
}

export const categoryAdapter: EntityAdapter<Category> = createEntityAdapter<Category>();

export const initialCategoryState: CategoryState = categoryAdapter.getInitialState({
  loadingCategory: false,
  categoryLoaded: false,
});

export const reducer = createReducer(
  initialCategoryState,
  on(categoryActions.getCategoriesSuccess, (state, { categories }) => {
    return categoryAdapter.setAll(categories, {
      ...state,
    });
  }),
  on(categoryActions.saveCategory, (state) => {
    return {
      ...state,
      loadingCategory: true,
      categoryLoaded: false,
    };
  }),
  on(categoryActions.saveCategorySuccess, (state, { newCategory }) => {
    return categoryAdapter.addOne(newCategory, {
      ...state,
      loadingCategory: false,
      categoryLoaded: true,
    });
  }),
  on(categoryActions.saveCategoryError, (state) => {
    return {
      ...state,
      loadingCategory: false,
      categoryLoaded: false,
    };
  }),
  on(categoryActions.deleteCategorySuccess, (state, { deletedCategory }) => {
    return categoryAdapter.removeOne(deletedCategory?.id, {
      ...state,
    });
  })
);

export function CategoryReducer(state: CategoryState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = categoryAdapter.getSelectors();
